import 'components/_Assets/scss/srprs.scss'
import Layout from 'components/Layout'
import { Colour } from 'components/variables'
import * as React from 'react'
import { DisplayPage } from 'react-content-engine'
import { connect, ConnectedProps } from 'react-redux'
import { match } from 'react-router'
import { Dispatch } from 'redux'
import {
  fetchContent,
  fetchSections,
  fetchSegments,
  setContent,
} from '../../data/api/content'
import { Theme } from '../../data/models/funnelOrder/theme'
import { SiteCountry, SiteLanguage } from '../../data/models/locale'
import { changePageColor, randomPageColor } from '../../data/models/page'
import { AppState } from '../../data/state'
import SmochChat from '../../elements/chat/SmochChat'
import IfMobile from '../../elements/conditionals/IfMobile'
import Footer, { NormalFooter } from '../../elements/footers/normalFooter'
import SEO from '../../elements/SEO'
import history from '../../routing/history'
import { getNameWithTheme, Sredirect } from '../../routing/links'
import { updateLocation } from '../../tracking/actions/pageView'
import NavBar from './navbar'

interface Footer {
  alternative: boolean
}
interface PageProps extends PropsFromRedux {
  page: string
  match?: match<{}>
  children: any
  color?: Colour
  navBarType?: string
  navBarOverrideColour?: 'black' | 'white'
  hideMenu?: boolean
  navFooter?: boolean
  orderPriceRequired?: boolean
  stopTracking?: boolean
  noContent?: boolean
  whiteBackground?: boolean
  footer?: NormalFooter
}

class Page extends React.Component<PageProps> {
  public UNSAFE_componentWillMount() {
    if (this.props.color) {
      this.props.changePageColor(this.props.color)
    } else {
      this.props.randomPageColor()
    }
  }

  public componentDidMount() {
    if (!this.props.stopTracking) {
      updateLocation(history.location)
    }
  }

  public render() {
    const {
      orderPriceRequired,
      orderPrice,
      noContent,
      whiteBackground,
      pageColor,
      footer = {},
    } = this.props

    if (orderPriceRequired && Number.isNaN(orderPrice)) {
      return <Sredirect name={getNameWithTheme('customise')} />
    }
    let extraProps = {}
    if (DisplayPage.displayName === 'Connect(EditablePage)') {
      extraProps = { fetchSegments, fetchSections, setContent }
    }

    let fetchContentHandler = fetchContent
    if (noContent) {
      fetchContentHandler = (page: string, segment: string) => {
        return Promise.resolve({
          pageContent: {},
          defaultContent: {},
        })
      }
    }

    return (
      <>
        {this.props.match !== undefined ? (
          <SEO match={this.props.match} pageName={this.props.page} />
        ) : null}

        <DisplayPage
          page={this.props.page}
          segment={this.props.language!}
          fetchContent={fetchContentHandler}
          {...extraProps}
        >
          <Layout color={pageColor} whiteBackground={whiteBackground}>
            {/* Navbar */}
            {this.props.match !== undefined ? (
              <NavBar
                type={this.props.navBarType}
                match={this.props.match}
                hideMenu={this.props.hideMenu}
                overrideColour={this.props.navBarOverrideColour}
                confirmCountryChange={orderPriceRequired}
              />
            ) : null}
            {/* Content */}
            <div>{this.props.children}</div>
            {/* Footer */}
            {!this.props.navFooter || this.props.match === undefined ? null : (
              <Footer {...footer} />
            )}
          </Layout>
        </DisplayPage>
      </>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  language: state.locale.language,
  country: state.locale.country,
  pageColor: state.page.color,
  orderPrice: state.funnelOrder.total,
  theme: state.funnelOrder.theme,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  changePageColor: (color: Colour) => {
    dispatch(changePageColor(color))
  },
  randomPageColor: () => {
    dispatch(randomPageColor())
  },
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(Page)
